import { CustomElement } from 'react-hook-form';
import * as React from 'react';

export interface ITextarea {
  name?: string;
  placeholder?: string;
  register?: (ref: HTMLTextAreaElement | CustomElement<any> | null) => void;
  size?: 'small' | 'medium' | 'large';
  rounded?: boolean;
  id?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  value?: string;
  defaultValue?: string;
  readOnly?: boolean;
  maxLength?: number;
  rows?: number;
  cols?: number;
  disableResize?: boolean;
  dataTestId?: string;
  counterLimit?: number;
  hasError?: boolean;
  UNSAFE_className?: string;
}

const themeFontSize = {
  small: '14px',
  medium: '16px',
  large: '16px',
};

const Textarea: React.FC<ITextarea> = ({
  name,
  placeholder,
  register,
  size = 'medium',
  rounded = false,
  id,
  value,
  defaultValue,
  onChange,
  onKeyDown,
  readOnly,
  maxLength,
  rows,
  cols,
  disableResize = false,
  dataTestId,
  counterLimit,
  hasError = false,
  UNSAFE_className = '',
}) => {
  const [counter, setCounter] = React.useState(0);

  return (
    <>
      <textarea
        id={id}
        name={name}
        placeholder={placeholder}
        ref={register}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        defaultValue={defaultValue}
        readOnly={readOnly}
        maxLength={maxLength}
        rows={rows}
        cols={cols}
        data-testid={dataTestId}
        className={UNSAFE_className}
        onInput={(e) => {
          setCounter(e.currentTarget.value.length);
        }}
      />
      {counterLimit && (
        <span className="counter">{`${counter}/${counterLimit}`}</span>
      )}
      <style jsx>{`
        textarea {
          display: block;
          width: 100%;
          line-height: 1.5;
          background-color: #fff;
          background-image: none;
          border: 1px solid var(--clr-tertiary-2);
          border-radius: ${!rounded ? 6 : 30}px;
          height: 100%;
          padding: var(--space-2) var(--space-4);
          ${size ? `font-size: ${themeFontSize[size]}` : ''};
          transition: border-color ease-in-out 0.15s,
            box-shadow ease-in-out 0.15s;
          outline: none;
          -webkit-appearance: none;
          font-family: var(--font-family-body);
          ${disableResize ? 'resize: none;' : ''}
          ${hasError ? 'border-color: var(--clr-danger);' : ''}
        }

        .counter {
          font-family: var(--font-family-body);
          text-align: right;
          margin-top: var(--space-1);
          font-size: 14px;
          display: flex;
          justify-content: flex-end;
        }
      `}</style>
    </>
  );
};

export default Textarea;
